import { Anchor, Card, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router";
import { devotionalPlainText } from "@how/website-core";
import { isTodays, useChurchToday, useTodaysDevotional } from "../devotionals/devotional-queries";

/** How much of the reflection Home shows before "Read today's devotional". */
const PREVIEW_LENGTH = 200;

export function previewOf(text: string): string {
  const flat = text.replace(/\s+/g, " ").trim();
  if (flat.length <= PREVIEW_LENGTH) return flat;
  const cut = flat.slice(0, PREVIEW_LENGTH);
  const space = cut.lastIndexOf(" ");
  return `${(space > PREVIEW_LENGTH / 2 ? cut.slice(0, space) : cut).trimEnd()}…`;
}

/**
 * Today's devotional on Home (ADR 0077): its title, passage reference and the start of the reflection, in a church
 * with the module and only when there is one to read. When none is dated today it says "The latest devotional".
 */
export function DevotionalCard() {
  const devotional = useTodaysDevotional();
  const today = useChurchToday();
  // No module, no permission, nothing published yet: the card says nothing rather than something empty.
  if (devotional.isPending || devotional.isError || devotional.data === null) return null;
  const d = devotional.data;
  const todays = isTodays(d, today);
  const preview = previewOf(devotionalPlainText(d));
  return (
    <Card data-testid="devotional-card">
      <Stack gap="xs">
        <Title order={2} size="h4">
          {todays ? "Today's devotional" : "The latest devotional"}
        </Title>
        <Text fw={600}>{d.title}</Text>
        {d.scripture.reference === null ? null : (
          <Text size="sm" c="dimmed">
            {d.scripture.reference}
          </Text>
        )}
        {preview === "" ? null : <Text size="sm">{preview}</Text>}
        <Anchor component={Link} to="/devotionals" size="sm">
          {todays ? "Read today's devotional" : "Read the latest devotional"}
        </Anchor>
      </Stack>
    </Card>
  );
}
